import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './LegalModal.css';

const LEGAL_TYPES = {
  ml: { title: 'Mentions légales', endpoint: 'ml' },
  pdc: { title: 'Politique de confidentialité', endpoint: 'pdc' },
  cgu: { title: "Conditions générales d'utilisation", endpoint: 'cgu' },
};

function LegalModal({ type, isOpen, onClose }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const config = LEGAL_TYPES[type] || LEGAL_TYPES.ml;
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

  useEffect(() => {
    if (isOpen && !content) {
      fetchLegal();
    }
  }, [isOpen]);

  const fetchLegal = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${backendUrl}/legals/getLegal/${config.endpoint}`);
      const data = await response.json();
      if (data?.data?.content) {
        setContent(data.data);
      } else {
        setError('Contenu non disponible');
      }
    } catch (err) {
      console.error('Erreur chargement:', err);
      setError('Impossible de charger le contenu');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
        <div className="legal-modal__header">
          <h2 className="legal-modal__title">{config.title}</h2>
          {content?.date && (
            <span className="legal-modal__date">
              En date du {new Date(content.date).toLocaleDateString('fr-FR')}
            </span>
          )}
          <button className="legal-modal__close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="legal-modal__content">
          {loading && (
            <div className="legal-modal__loading">
              <div className="legal-modal__spinner" />
              <p>Chargement...</p>
            </div>
          )}
          
          {error && (
            <div className="legal-modal__error">
              <p>{error}</p>
            </div>
          )}
          
          {content?.content && (
            <div 
              className="legal-modal__text"
              dangerouslySetInnerHTML={{ __html: content.content }} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default LegalModal;

